/** @type {Storage} */
export const sessionData = window.sessionStorage;

/** @type {Function} */
export const meiroEvents = window.MeiroEvents;

/** @type {Function} */
export const { didomiOnReady } = window;

/** @type {Function} */
export const { dataLayer } = window;

/** @type {String} */
export const CLASS_ANSWERS = 'enquiry-bars__answers';

/** @type {String} */
export const CLASS_SINGLE_ANSWER_HOVER = 'enquiry-bars-answers__answer--hover';

/** @type {String} */
export const CLASS_ANSWER_INDICATOR = 'enquiry-bars-answer__indicator';

/** @type {String} */
export const CLASS_ANSWER_STATEMENT = 'enquiry-bars-answer__statement';

/** @type {String} */
export const CLASS_ANSWER_STATEMENT_SELECTED = `${CLASS_ANSWER_STATEMENT}--selected`;

/** @type {String} */
export const CLASS_FOOTER_NOTICE = 'enquiry-bars-footer__vote-notice';

/** @type {String} */
export const CLASS_FOOTER_TOTAL_VOTES = 'enquiry-bars-footer__total-votes';

/** @type {String} */
export const CLASS_RESULT_NOTICE_LINK = 'enquiry-bars-result-notice__link';
